import { createAction } from 'redux-actions'
import {
  VISIT_SUBSCRIPTION_PAGE,
  UNSET_SUBSCRIPTION_VISIT,
  SELECT_SUBSCRIPTION_PLAN,
} from 'Redux/Types/SubscribeTypes'

export const visitSubscriptionPage = createAction(VISIT_SUBSCRIPTION_PAGE)
export const unsetSubscriptionVisit = createAction(UNSET_SUBSCRIPTION_VISIT)
export const selectSubscriptionPlan = createAction(SELECT_SUBSCRIPTION_PLAN)
